// App store
export const appStoreUrl =
  'https://apps.apple.com/jp/app/every-live-%E3%82%A8%E3%83%96%E3%83%AA%E3%82%A3%E3%83%A9%E3%82%A4%E3%83%96-%E3%83%BC-%E3%83%A9%E3%82%A4%E3%83%96%E9%85%8D%E4%BF%A1%E3%82%A2%E3%83%97%E3%83%AA/id1544907634?ign-itsct=apps_box&ign-itscg=30200';

// Play store
export const playStoreUrl =
  'https://play.google.com/store/apps/details?id=jp.stageinc.app.blue';

// every live home page
export const homePageUrl = 'https://everylive.jp';
